import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
           phoneNum : "",
           nickName:'',

        }
    },
    validators: {
        nickName: function (value) {
            return Validator.value(value)
                .required('닉네임을 입력해주세요.')
        },
        phoneNum: function (value) {
            return Validator.value(value)
            .required('전화번호를 입력해 주세요.')
            .minLength(8, '전화번호를 입력해 주세요.')
            .regex('^[0-9|]+$', '전화번호를 입력해 주세요.')
            .maxLength(11, '전화번호를 입력해 주세요.')
        },
    }
}
